import styled from "styled-components";

export const LoaderAnimatedContainer = styled.div`

`
